import React from 'react';
import './NoPage.css';

export default function NoPage() {
  return (
    <div>
      <div className="error-cover">  
        <img src='/images/workinprogress.png' alt='Working in progress'  className='workinprogress' />
      </div>
      <div className='error-container'>
        <h2 className="nopage">Opps! Sorry the page is under construction</h2>
      </div>
      <div className='error-btn'>
      <a href="/home" className='button-link'>Click here to go back home</a>
      </div>
    </div>
  )
}
